import classNames from 'classnames/bind';
import React, { useContext } from 'react';
import { RiEditLine, RiDeleteBinLine } from 'react-icons/ri';

import styles from './MissionRow.module.scss';
import { MissionTableContext } from './MissionTableContext';

import { IconButton } from '@/components/ui/kit/Button';
import { deleteMission } from '@/helpers/Requester';
import dayjs from '@/libs/dayjs';

const cx = classNames.bind(styles);

const MissionRow = ({ mission }) => {
  const { handleSelectMission, handleDeleteMission, selectedMissionId, showMissionEdit } =
    useContext(MissionTableContext);

  const handleClick = () => {
    handleSelectMission(mission);
  };

  const moveToEdit = (e) => {
    e.stopPropagation();
    window.open(`/mission-hub/${mission.id}`);
  };

  const doDelete = (e) => {
    e.stopPropagation();

    deleteMission(mission.id).then(({ success }) => {
      if (success) {
        if (selectedMissionId === mission.id) {
          handleSelectMission(null);
        }
        handleDeleteMission(mission.id);
      }
    });
  };

  return (
    <div className={cx(['container', { target: mission.id === selectedMissionId }])} onClick={handleClick}>
      <div className={cx(['column', 'protocol'])}>MavLink</div>
      <div className={cx(['column', 'name'])}>{mission.name}</div>
      <div className={cx(['column', 'time'])}>{dayjs(mission.updatedAt).format('YYYY-MM-DD HH:mm')}</div>
      <div className={cx(['column', 'control'])}>
        {showMissionEdit && <IconButton type="mini" onClick={moveToEdit} Icon={RiEditLine} />}
        <IconButton type="mini" onClick={doDelete} Icon={RiDeleteBinLine} />
      </div>
    </div>
  );
};

export default MissionRow;
